/**
 * Merkt sich je PinboardStore, aus welchem Ergebnis der TimetableVersionData-Query er zuletzt befüllt wurde.
 *
 * Der Store einer Version lebt im StoreHandler über das Verlassen der Version hinaus, der TimetableProvider
 * dagegen wird bei jedem Betreten neu eingehängt. Die Merkliste hängt deshalb am Store und nicht an der
 * Komponente: Ein Ergebnis, mit dem der Store schon befüllt wurde, darf ihn nicht noch einmal befüllen –
 * sonst würde z. B. das veraltete Ergebnis aus dem urql-Cache die (optimistisch) gesteckten Karten
 * überschreiben. Eine Merkliste je Komponente (useRef) taugt dafür nicht: Sie ist nach jedem Betreten
 * leer, und React (StrictMode) führt Effekte beim Einhängen zweimal aus.
 */
const appliedVersionData = new WeakMap<object, object>();

/** Nach dem ersten Befüllen eines neuen Stores aufrufen. */
export function markVersionDataApplied(store: object, versionData: object): void {
  appliedVersionData.set(store, versionData);
}

/**
 * `true`, wenn der Store mit diesem Ergebnis noch nicht befüllt wurde; das Ergebnis gilt danach als
 * übernommen. Bei `false` nichts tun.
 */
export function claimVersionData(store: object, versionData: object): boolean {
  if (appliedVersionData.get(store) === versionData) return false;
  appliedVersionData.set(store, versionData);
  return true;
}
